import React, { Component, Fragment } from 'react';
import { Container } from 'reactstrap';
import NavMenu from './NavMenu';


export class Layout extends Component {
    static displayName = Layout.name;

    render() {
        return (
            <Fragment>
                <div style={{ paddingBottom:"30px" }} >
                    <NavMenu />
                    <Container>
                        {this.props.children}
                    </Container>


                </div>

                <footer className="footer border-top pl-3 text-muted" style={{ position: "fixed", bottom: "0", width: "100%", backgroundColor: "whitesmoke", lineHeight:"30px" }} >
                    <div className="container" style={{padding:"10px 0px"}} >
                        &copy; 2022 - In&#353;titut za kontrolo in certifikacijo v kmetijstvu in gozdarstvu Maribor

                    </div>
                </footer>
            </Fragment>
        );
    }
}
